// extracted by mini-css-extract-plugin
module.exports = {"alert_bpx":"TopAlert_alert_bpx__K9fxr"};